import SubordinateItem from './SubordinateItem'
import {useEffect, useState} from 'react'
import API from '../API';
import AddUser from './AddUser';
import Modal from './Modal';
import { componentOpenAdd } from './utils';

export default function SubordinatesList({id}) {
	const api = new API()
	const [users, setUsers] = useState([])
	const getUser = () => {
		api.getUsersByOrganization(id || localStorage.getItem('idO')).then(result => setUsers(result.users))
	}
	useEffect(() => {
		getUser()
	}, [id])

	function deleteItem(id) {
		api.deleteUser(id).then(data =>
			setUsers(prev => {
				return prev.filter(item => item.id !== id)
			}))
	}

	const elements = users.map(item => {
		const {id, ...itemProps} = item;
		return (
			<SubordinateItem
				key={id}
				idSub={id}
				{...itemProps}
				onDelete={deleteItem}
			/>
		)
	})


	return (
		<>
			<div>
				{/*<button className='profile_additional-button profile_import-button'>{language.import}</button>*/}
				<table className="organization_table subordinate_table">
					<tbody>
					{elements}
					</tbody>
				</table>
				<Modal additional={() => getUser()} componentOpen={componentOpenAdd} component={AddUser}/>
			</div>
		</>
	);
}